export const isApiGatewayUrl = (url: string): boolean => ['/gateway/api'].includes(url);
